import type { SingleGameFragment } from "@workspace/casino_core/fragments/SingleGameFragment";
import GameDetailsRow from "./shared/GameDetailsRow";

type Props = Pick<SingleGameFragment, "payLines">;

const PaylinesRow: FC<Props> = ({ payLines }) => {
  if (!payLines) {
    return null;
  }
  return (
    <GameDetailsRow translateId="casino.paylines">{payLines}</GameDetailsRow>
  );
};

export default PaylinesRow;
